import enrolLoyaltyEarnDecision from 'actions/loyalty/enrolLoyaltyEarnDecision'
import type { DefinedAppAction } from 'actions/types/ActionTypes'
import type { ApiActionResult } from 'middlewares/apiMiddleware'
import type { ThunkAction } from 'redux-thunk'
import type { ChooseDoubleRewardsChoice } from '../utils/loyaltyChooseDoubleRewardsState'
import getLoyaltyChooseDoubleRewardsCampaignMetadata from '../selectors/getLoyaltyChooseDoubleRewardsCampaignMetadata'
import getLoyaltyCanEnrolChooseDoubleRewards from '../selectors/getLoyaltyCanEnrolChooseDoubleRewards'

type Result = ApiActionResult<Array<App.LoyaltyEarnDecision>> | { status: 'blocked' }

/**
 * Runs pre-enrolment checks.
 * Expects callers to check that the takeover is active.
 * (Not enforced here due to circular dependency.)
 * BE enforces campaign data-range validation, so it will
 * fail any way.
 */
function enrolLoyaltyChooseDoubleRewards(choice: ChooseDoubleRewardsChoice): ThunkAction<Promise<Result>, App.State, undefined, DefinedAppAction> {
  return async(dispatch, getState) => {
    const state = getState()

    const config = getLoyaltyChooseDoubleRewardsCampaignMetadata(state)
    if (!config || !getLoyaltyCanEnrolChooseDoubleRewards(state, choice)) return { status: 'blocked' }

    const { doublePointsChoiceId, doubleStatusCreditsChoiceId } = config

    return await dispatch(
      enrolLoyaltyEarnDecision(
        choice === 'points' ? doublePointsChoiceId : doubleStatusCreditsChoiceId),
    ) ?? { status: 'blocked' }
  }
}

export default enrolLoyaltyChooseDoubleRewards
